<template>
    <div>
        <v-container fluid>
            <v-layout row>
                <v-flex style="display: flex; align-items: center; justify-content: center;">
                    <v-card class="card--flex-toolbar" style="width: 700px;">
                        <v-toolbar card dense color="primary" dark>
                        <v-toolbar-title>2019 Recommended Media Mix</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon>
                            <v-icon>info</v-icon>
                        </v-btn>
                        </v-toolbar>
                        <v-divider></v-divider>
                        <v-card-text>
                        <v-layout row>
                            <v-flex>
                                <div style="display: flex; align-items: center; justify-content: center;">
                                    <NestedPie :series="nestedPieData.series" :text="nestedPieData.periodName" subtext="vs 2018" style="height: 250px; margin-top: -20px;"/>
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex>
                                <div style="display: flex; align-items: center; justify-content: center; margin-top: -40px;">
                                    <div style="width: 700px; height: 300px;">
                                        <v-chart :options="areaGraphOptions" ref="mixChart"/>
                                        &nbsp;
                                    </div>
                                </div>
                            </v-flex>
                        </v-layout>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>

import datasource from '@/data'

import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import numbro from 'numbro'

import NestedPie from '../components/NestedPie.vue'

export default {
  components: {
    NestedPie,
    'v-chart': ECharts
  },
  mounted () {
      this.$refs.mixChart.chart.on('updateAxisPointer', (event) => {
        var xAxisInfo = event.axesInfo[0]
        if (xAxisInfo) {
          this.activePeriod = event.dataIndex
        } else {
            this.activePeriod = -1
        }
      })
  },
  computed: {
      areaGraphSeries: function () {
          var rec = datasource.recommendation
          var cha = datasource.channels
          var series = []
          for (var i = 0; i < cha.channelNames.length; i++) {
              series.push({
                    name: cha.channelNames[i],
                    type: 'line',
                    stack: 'Media',
                    areaStyle: {},
                    data: rec.channelProposedMix[i],
                    itemStyle: {
                        color: cha.channelColors[i]
                    },
                    showSymbol: false,
                    smooth: true
              })
          }
          return series
      },
      areaGraphOptions: function () {
          return {
            tooltip : {
                trigger: 'axis',
                formatter: this.formatAreaTooltip
            },
            xAxis : [
                {
                    type : 'category',
                    boundaryGap : false,
                    data : datasource.recommendation.periods.shortNames,
                    show: true,
                    axisLabel: {
                        color: 'black',
                        fontFamily: 'Roboto,sans-serif',
                        fontSize: '14'
                    },
                }
            ],
            yAxis : [
                {
                    type : 'value',
                    show: false,
                    max: 100
                }
            ],
            series : this.areaGraphSeries
        }
      },
      nestedPieSeries: function () {
          var rec = datasource.recommendation
          var cha = datasource.channels
          var series = []
          for (var i = 0; i < cha.channelNames.length; i++) {
              if (this.activePeriod >= 0) {
                  series.push({
                    name: cha.channelNames[i],
                    oldValue: rec.channelReferenceMix[i][this.activePeriod],
                    newValue: rec.channelProposedMix[i][this.activePeriod]
                })
              } else {
                  series.push({
                      name: cha.channelNames[i],
                      oldValue: rec.channelReferenceMix[i].reduce((a, b) => a + b),
                      newValue: rec.channelProposedMix[i].reduce((a, b) => a + b),
                  })
              }
          }
          return series
      },
      nestedPieData() {
        var activePeriod = '2019'
        if (this.activePeriod >= 0) {
            activePeriod = datasource.recommendation.periods.longNames[this.activePeriod]
        }
        return {
            periodName: activePeriod,
            series: this.nestedPieSeries
        }
    }
  },
  methods: {
      formatAreaTooltip: function (params) {
          var tooltip = ''
          for (let index = params.length-1; index >= 0; index--) {
              const param = params[index];
              tooltip += `
                <b style="color: ${param.color}">▶</b>
                <b>${param.seriesName}</b>:
                <span style="color: lightblue; font-size: 16px;">${param.value}%</span>
                <br>
              `
          } 
          return tooltip
      },
      mouseOver: function (event) {
          console.log(event)
      },
      formatCurrency: function (value) {
          return numbro(value).formatCurrency({
                average: true,
                mantissa: 1,
                optionalMantissa: true
            })
      }
  },
  data () {
    return {
        activePeriod: -1
    }
  }
}
</script>

<style>
    .echarts {
        width: 100%;
        height: 100%;
    }
</style>